import { useState, useEffect } from 'react';

// Generate a UUID v4
const generateUUID = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback for older browsers
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0;
    // eslint-disable-next-line no-bitwise
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const GUEST_ID_KEY = 'guestId';

export function useGuestId() {
  const [guestId, setGuestId] = useState(() => {
    // Initialize from localStorage if available
    if (typeof window !== 'undefined') {
      return localStorage.getItem(GUEST_ID_KEY);
    }
    return null;
  });

  useEffect(() => {
    // If no guest ID exists, generate one
    if (!guestId) {
      const newGuestId = generateUUID();
      localStorage.setItem(GUEST_ID_KEY, newGuestId);
      setGuestId(newGuestId);
    }
  }, [guestId]);

  return guestId;
}

export default useGuestId;
